import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]
  static values = {
    successMessage: { type: String, default: "Copied!" },
    defaultMessage: { type: String, default: "Copy Link" }
  }

  connect() {
    // Initial setup
  }

  copy() {
    const textToCopy = this.sourceTarget.value
    
    // Select the text and copy to clipboard
    this.sourceTarget.select()
    document.execCommand('copy')
    
    // Show visual feedback
    if (this.hasButtonTarget) {
      const originalText = this.buttonTarget.innerText
      this.buttonTarget.innerText = this.successMessageValue
      
      // Reset button text after 2 seconds
      setTimeout(() => {
        this.buttonTarget.innerText = this.defaultMessageValue
      }, 2000)
    }
    
    // Deselect the text
    window.getSelection().removeAllRanges()
  }
}